import { _apiV2_get } from "@/app/api2"
import { APIFirmResponse, APIFundResponse } from "@/app/types"

// ########## Fund API ##########
export async function apiv2_getFunds() {
  return _apiV2_get("/funds", { key: "getFunds()", cacheLS: true })
}

export async function apiv2_getFund(
  fundId: string
): Promise<APIFundResponse.FundData> {
  const key = `getFund(${fundId})`
  return _apiV2_get(`/funds/${fundId}`, {
    key,
    cacheLS: true,
  })
}

export async function apiv2_getFundCustomLists(
  fundId: string
): Promise<APIFundResponse.FundData> {
  const key = `getFundCustomLists(${fundId})`
  return _apiV2_get(`/funds/${fundId}/custom`, {
    key,
    cacheLS: true,
  })
}

// ########## Firm API ##########
export async function apiv2_getFirms() {
  return _apiV2_get("/firms", {
    key: "getFirms()",
    cacheLS: true,
  })
}

export async function apiv2_getFirm(
  firmId: string,
  filter?: string
): Promise<APIFirmResponse.FirmData> {
  const key = filter ? `getFirm(${firmId}-${filter})` : `getFirm(${firmId})`
  return _apiV2_get(`/firms/${firmId}`, {
    key,
    cacheLS: true,
    queryParam: { filter },
  })
}

export async function apiv2_getFirmCustomLists(
  firmId: string
): Promise<APIFirmResponse.FirmData> {
  const key = `getFirmCustomLists(${firmId})`
  return _apiV2_get(`/firms/${firmId}/custom`, {
    key,
    cacheLS: true,
  })
}
